<div 
  class="circle-background-container"
  [style.height]="isMobile ? backgroundCircleDiameterMobile : backgroundCircleDiameter"
  [style.width]="isMobile ? backgroundCircleDiameterMobile : backgroundCircleDiameter"
>
  <em
    [class]="icomoonClassName"
    [style.fontSize]="isMobile ? iconSizeMobile : iconSize"
  ></em>
  <div class="circle-background"></div>
</div>